export function hapticImpact(style: 'light' | 'medium' | 'heavy' = 'medium') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tg = (window as any).Telegram?.WebApp
  tg?.HapticFeedback?.impactOccurred?.(style)
}

export function hapticNotification(type: 'success' | 'warning' | 'error') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tg = (window as any).Telegram?.WebApp
  tg?.HapticFeedback?.notificationOccurred?.(type)
}
